/* 
 *	Filter functions 
 *
 *  www.idea-tags.com
*/

var Filter = {
    
	// Initialize controls
  initFilters: function() {
  	var form = $('form.product-filters');
    var carrierSelect = $('select#filter-carrier', form);
    var brandSelect = $('select#filter-brand', form);
    var modelSelect = $('select#filter-model', form);
		var button = $('button', form);
      
    $.each(productPhones, function(carrier, brands) { 
    	carrierSelect.append($("<option></option>")
      	.attr("value", carrier)
      	.text(carrier));
    });
    
    carrierSelect.change(Filter.carrierSelected);
    brandSelect.change(Filter.brandSelected);
    modelSelect.change(Filter.modelSelected);
    button.click(Filter.formSubmit);
      
    brandSelect.prop('disabled', true);
    modelSelect.prop('disabled', true);
    button.prop('disabled', true);
    
    if (!$.isEmptyObject($.QueryString))
    	Filter.initFromParameters();
  },
  
  initFromParameters: function() {
    var form = $('form.product-filters');
    var carrierSelect = $('select#filter-carrier', form);
    var brandSelect = $('select#filter-brand', form);
    var modelSelect = $('select#filter-model', form);
		var button = $('button', form);
    
    var qs = $.QueryString;
    var carrier = qs['filter-carrier'];
    var brand = qs['filter-brand'];
    var model = qs['filter-model'];
    //console.log(carrier, brand, model);
    
    if ((carrier) && (productPhones[carrier])) {
    	carrierSelect.val(carrier);
      var brands = productPhones[carrier];
      
      $.each(brands, function(brand, models) { 
    		brandSelect.append($("<option></option>")
     	 		.attr("value", brand)
      		.text(brand));
    	});
      brandSelect.prop('disabled', false);
      
      if ((brand) && (brands[brand])) {
				brandSelect.val(brand);
        var models = brands[brand];
        
        $.each(models, function(i, model) { 
    			modelSelect.append($("<option></option>")
     	 			.attr("value", model)
      			.text(model));
    		});
        modelSelect.prop('disabled', false);
        
        if ((model) && ($.inArray(model, models) > -1)) {
          modelSelect.val(model);
          button.prop('disabled', false);
        }
        
      }
    }
  },
  
  carrierSelected: function(e) {
    var form = $('form.product-filters');
    var brandSelect = $('select#filter-brand', form);
    var modelSelect = $('select#filter-model', form);
    var button = $('button', form);
    
    var carrier = $(this).val();
    var brands = productPhones[carrier];
    
    $("option", brandSelect).not(":eq(0)").remove();
    $("option", modelSelect).not(":eq(0)").remove();
    
    if (brands) {
      
    	$.each(brands, function(brand, models) { 
    		brandSelect.append($("<option></option>")
     	 	.attr("value", brand)
      		.text(brand));
    	});
    
    	brandSelect.prop('disabled', false).focus();
    } else {
      brandSelect.prop('disabled', true);
  	}
    modelSelect.prop('disabled', true);
    button.prop('disabled', true);
  },
  
  brandSelected: function(e) {
    var form = $('form.product-filters');
    var carrierSelect = $('select#filter-carrier', form);
    var brandSelect = $('select#filter-brand', form);
    var modelSelect = $('select#filter-model', form);
    var button = $('button', form);
    
    var carrier = $('option:selected', carrierSelect).val();
    var brand = $(this).val();
    var models = productPhones[carrier][brand];

    
    $("option", modelSelect).not(":eq(0)").remove();
    
    if (models) {
      
    	$.each(models, function(i, model) { 
    		modelSelect.append($("<option></option>")
     	 	.attr("value", model)
      		.text(model));
    	});
    
    	modelSelect.prop('disabled', false).focus();
    } else {
      modelSelect.prop('disabled', true);
  	}
    button.prop('disabled', true);
  },
  
  modelSelected: function(e) {
    var form = $('form.product-filters');
    var carrierSelect = $('select#filter-carrier', form);
    var brandSelect = $('select#filter-brand', form);
    var modelSelect = $('select#filter-model', form);
    var button = $('button', form);
    
    var model = $(this).val();
    if (model) {
      button.prop('disabled', false).focus();
    } else {
      button.prop('disabled', true);
    }
    
  },
  
  formSubmit: function(e) {
    var form = $('form.product-filters');
    var carrierSelect = $('select#filter-carrier', form);
    var brandSelect = $('select#filter-brand', form);
    var modelSelect = $('select#filter-model', form);
    
    var carrier = $('option:selected', carrierSelect).val();
    var brand = $('option:selected', brandSelect).val();
    var model = $('option:selected', modelSelect).val();
    
    if ((carrier) && (brand) && (model)) {
    
    	var params = {
      	'filter-carrier': carrier,
      	'filter-brand': brand,
      	'filter-model': model
    	}
      
      var tag = carrier + '-' + brand + '-' + model;
      tag = tag.toLowerCase().replace(/ /g, '-').replace('--', '-').replace(/[^0-9a-z_\-]/g, '');
    
    	var url = '/collections/all/';		// window.location.toString().replace(/\?.*/, "")
      url += tag + "?" + $.param(params);
    	//console.log(carrier, brand, model);
    	//console.log(url);
    
    	window.location = url;
    }
    
    return false;
  }
};

// QueryString parameter values
// http://stackoverflow.com/a/3855394/174245
(function($) {
    $.QueryString = (function(a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i)
        {
            var p=a[i].split('=');
            if (p.length != 2) continue;
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'))
})(jQuery);

Filter.initFilters();